import React, { useEffect, useRef } from 'react';

const PhotoEditor = () => {
    const link = 'https://davienodebackenddev.azurewebsites.net/';
    return (
        <div style={{ width: '100%', height: '100vh', marginTop: '70px' }}>
            <iframe
                src={link}
                title="Embedded Content"
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        </div>
    );
};

export default PhotoEditor;
